/**
 * TanStack Router: /sign-documents
 *
 * This route file was auto-generated by the route generation script.
 * Component: SignDocumentsPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import SignDocumentsPage from '@/app/sign-documents/page'

/**
 * Route: /sign-documents
 * Layout: _auth (authenticated)
 * Component: SignDocumentsPage
 */
export const Route = createFileRoute('/_auth/sign-documents')({
  component: SignDocumentsPage,
})
